document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".button--sortiment");
  const explanations = document.querySelectorAll(".text-explanation-sortiment");
  const triangles = document.querySelectorAll(".triangle-left-sortiment svg");

  buttons.forEach((button, index) => {
    button.addEventListener("click", function () {
      // Remove active class from all buttons, explanations, and triangles
      buttons.forEach((btn) => btn.classList.remove("active"));
      explanations.forEach((explanation) =>
        explanation.classList.remove("active")
      );
      triangles.forEach((triangle) => triangle.classList.remove("active"));

      // Add active class to the clicked button, corresponding explanation, and triangle
      button.classList.add("active");
      explanations[index].classList.add("active");
      triangles[index].classList.add("active");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const toggleHeading = document.querySelector(
    ".sortiment-mini--heading-w-icon"
  );
  const popupErklarung = document.querySelector(".sortiment-popup-erklarung");
  const containerMainSortiment = document.querySelector(
    ".inner-container-sortiment-coll"
  );

  toggleHeading.addEventListener("click", function () {
    // Toggle active class on the heading and the content
    toggleHeading.classList.toggle("active");
    popupErklarung.classList.toggle("active");
    containerMainSortiment.classList.toggle("active");
  });
});
